
import { importSync as i } from '@embroider/macros';
let d = window.define;
d("@ember/string/cache", function(){ return i("@ember/string/cache");});
d("@ember/string/index", function(){ return i("@ember/string/index");});
import "@ember/string/-embroider-implicit-modules.js";
